// extracted by mini-css-extract-plugin
module.exports = {"backgroundGradient":"styles_backgroundGradient__ZU3w1"};